// 模块名称，枚举type
export enum ModuleName  {
  /** 通用模块：commonModuleConfig */
  'ShareCouponModule' = 'ShareCouponModule',
  'NewUserModule' = 'NewUserModule',
  'wePointsModule' = 'wePointsModule',
  'weCouponModule' = 'weCouponModule',
  'bannerModule' = 'bannerModule',
  'ECashCoupon' = 'ECashCoupon',
  'commonShareModule' = 'commonShareModule',
  'ScanGiftModule' = 'ScanGiftModule',
  'mainlandActModule' = 'mainlandActModule', // 内地活动模块
  'bankActModule' = 'bankActModule', // 银行招商活动模块

  /** 商户专属模块：spModuleConfig */
  'VitasoyLotteryModule' = 'VitasoyLotteryModule', // 维他奶抽奖模块
}

/** 特殊排序值的枚舉，在此統一管理 */
export enum ExtraSortStatus {
  common = 1, // 普通extraSort排序值，用於迎新優惠碼，有券狀態的狂賞印組件
}

export type ModuleConfig = {
  moduleName: ModuleName, // 模块名称
  component: Vue.Component, // 模块对应的视图
  sort: number, // 模块通用排序，数字越大越靠前，範圍（1-99）
  extraSort?: number // 模塊特殊排序（優先級比sort高），數字越大越靠前，範圍(1-99)，默認為0.
};

/** 通用排序的權重值 */
export const SORT_WEIGHT = 1;
/** 特殊排序的權重值 */
export const EXTRA_SORT_WEIGHT = 100;
